import { Toggle } from "../../../components/Toggle";
import { InAppAnnouncementBanner } from "../components/InAppAnnouncementBanner";
import { SettingCard } from "../components/SettingCard";
import { settingsService } from "../services/settingsService";
import type { SettingsTabProps } from "./settingsTabTypes";

export const GeneralSettingsTab = ({ settings, onSettingsChange }: SettingsTabProps) => {
  const handleTogglePaywallShowPerWeekMode = async (value: boolean) => {
    await settingsService.updatePaywallShowPerWeekMode(value);
    onSettingsChange({ paywallShowPerWeekMode: value });
  };

  const handleToggleOnboardingShowAskForReview = async (value: boolean) => {
    await settingsService.updateOnboardingShowAskForReview(value);
    onSettingsChange({ onboardingShowAskForReview: value });
  };

  return (
    <>
      <InAppAnnouncementBanner />
      <SettingCard title="Paywall Show Per Week Mode">
        <Toggle checked={settings.paywallShowPerWeekMode} onChange={handleTogglePaywallShowPerWeekMode} />
      </SettingCard>
      <SettingCard title="Onboarding Show Ask For Review">
        <Toggle checked={settings.onboardingShowAskForReview} onChange={handleToggleOnboardingShowAskForReview} />
      </SettingCard>
    </>
  );
};
